export const PURCHASE_STATES = {
  LOCKED: 'locked',
  CHECKOUT_STARTING: 'checkout_starting',
  REDIRECTING: 'redirecting',
  VERIFYING: 'verifying',
  UNLOCKED: 'unlocked',
  ERROR: 'error',
};

export const PURCHASE_STATE_LABELS = {
  [PURCHASE_STATES.LOCKED]: 'Unlock',
  [PURCHASE_STATES.CHECKOUT_STARTING]: 'Starting checkout...',
  [PURCHASE_STATES.REDIRECTING]: 'Redirecting...',
  [PURCHASE_STATES.VERIFYING]: 'Verifying purchase...',
  [PURCHASE_STATES.UNLOCKED]: 'Unlocked',
  [PURCHASE_STATES.ERROR]: 'Try again',
};
